import React, { useState } from "react";
import "./Login.css";

export default function Login({ onLogin }) {
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const logoUrl = `${process.env.PUBLIC_URL || ""}/Logo.png`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError("");
    setLoading(true);
    try {
      await onLogin(form.username.trim(), form.password);
    } catch (err) {
      console.error(err);
      setError(err.message || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-showcase" aria-label="Alif Protiens operations">
        <div className="login-brand-strip">
          <img src={logoUrl} alt="" className="login-logo" />
          <div><div className="login-brand-title">Alif Protiens</div><div className="login-brand-subtitle">Stock & business management</div></div>
        </div>
        <div className="login-copy">
          <div className="login-eyebrow"><span /> YOUR DAILY OPERATIONS, SIMPLIFIED</div>
          <h1>A fresh start.<br />A better way<br />to <em>do business.</em></h1>
          <p>From the first delivery to the final bill, keep your stock, sales and payments in one place.</p>
          <div className="login-workflow" aria-label="Your workflow">
            <div><span>01</span><strong>Track stock</strong><small>Every inward, accounted for.</small></div>
            <div><span>02</span><strong>Manage billing</strong><small>Keep your counter moving.</small></div>
            <div><span>03</span><strong>Stay informed</strong><small>A clear view of your business.</small></div>
          </div>
        </div>
        <div className="login-showcase-footer"><span>Built for your everyday business.</span><span>ALIF PROTIENS</span></div>
      </section>
      <section className="login-panel" aria-labelledby="login-heading">
        <div className="login-panel-top"><span className="login-status-dot" /> Operations workspace</div>
        <div className="login-card-content">
          <div className="login-form-icon" aria-hidden="true">
            <svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><rect x="5" y="10" width="14" height="11" rx="3"/><path d="M8 10V7a4 4 0 0 1 8 0v3m-4 5v2"/></svg>
          </div>
          <div className="login-card-header">
            <div className="login-eyebrow">WELCOME BACK</div>
            <h2 id="login-heading">Sign in to your workspace</h2>
            <p>Enter your details to get your day started.</p>
          </div>
          {error ? <div id="login-error" className="login-alert" role="alert">{error}</div> : null}
          <form className="login-form" onSubmit={handleSubmit} aria-busy={loading} aria-describedby={error ? "login-error" : undefined}>
            <div className="login-field">
              <label htmlFor="login-username">Username</label>
              <input id="login-username" className="login-input" type="text" autoComplete="username" autoCapitalize="none" spellCheck={false} value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} placeholder="Enter your username" required disabled={loading} />
            </div>
            <div className="login-field">
              <label htmlFor="login-password">Password</label>
              <div className="login-password-row">
                <input id="login-password" className="login-input" type={showPassword ? "text" : "password"} autoComplete="current-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Enter your password" required disabled={loading} />
                <button type="button" className="login-toggle-btn" onClick={() => setShowPassword((v) => !v)} aria-label={showPassword ? "Hide password" : "Show password"} aria-pressed={showPassword}>{showPassword ? "Hide" : "Show"}</button>
              </div>
            </div>
            <button type="submit" className="login-submit-btn" disabled={loading}>
              <span>{loading ? "Signing in..." : "Sign in"}</span>
              <span aria-hidden="true">{loading ? "..." : "\u2192"}</span>
            </button>
          </form>
          <div className="login-footer-note">Need access or help signing in?<br /><strong>Contact your administrator.</strong></div>
        </div>
        <footer className="login-panel-footer">&copy; {new Date().getFullYear()} Alif Protiens. All rights reserved.</footer>
      </section>
    </main>
  );
}
